import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha'

// Logo ve görseller
import logo from '../../assets/img/odu-yatay.png'
import doku from '../../assets/img/bd-doku2.png'
import { BsArrowRightCircle, BsFillExclamationTriangleFill } from "react-icons/bs";


//Servisler
import getBasvuruByNo from '../../services/getBasvuruByNo';
import basvuruSorgulama from '../../services/basvuruSorgulama';
import aktifDonem from '../../services/aktifDonem';
import { Link } from 'react-router-dom';

const BasvuruSorgulama = () => {


    // google reCaptcha
    const recaptchaRef = React.createRef();
    const [recaptchaVerified, setRecaptchaVerified] = useState(false);

    const onChangeRecaptcha = (value) => {
        if (value) {
            setRecaptchaVerified(true);
        } else {
            setRecaptchaVerified(false);
        }
    };


    //İnputtan girilen başvuru değeri
    const [basvuruNo, setBasvuruNo] = useState("")
    // Başvuru no sistemde yoksa hata mesajı
    const [error, setError] = useState("")
    // Girilen başvuru numarasının sorgulanması ve sonuç gösterimi
    const [basvuruDurum, setBasvuruDurum] = useState("")
    //Başvuru numarasına ait kişi detayı
    const [basvuruDetay, setBasvuruDetay] = useState([])


    const handleSorgulama = async () => {
        const result = await basvuruSorgulama(basvuruNo)
        if (result) {
            //Başvuru varsa sonuçları setle
            setBasvuruDurum(result)
            //Başvuru kime aitse detay bilgilerini çek
            getBasvuruDetay()
            //error state boşalt
            setError("")

        } else {
            setError("Girmiş olduğunuz başvuru numarasarına ait kayıt bulunamamıştır")
        }

        recaptchaRef.current.reset();
        setRecaptchaVerified(false)
    }


    //Başvuru numarasına ait detay bilgileri getirme
    const getBasvuruDetay = async () => {
        const result = await getBasvuruByNo(basvuruNo)
        if (result) {
            setBasvuruDetay(result)
        }
    }

    //Aktif dönem bilgileri
    const [donem, setDonem] = useState()
    const getAktifDonem = async () => {
        const result = await aktifDonem()
        if (result) {
            setDonem(result)
        }
    }

    //console.log(process.env.REACT_APP_RECAPTCHA_KEY)


    const handleBasvuruDurum = () => {

        switch (basvuruDurum.basvuruDurumu) {

            case "0":
                return ("inceleme aşamasındadır.")
            case "1":
                return ("kabul edilmiştir.")
            case "2":
                return ("kabul edilmemiştir.")
            default: break
        }
    }

    useEffect(() => {
        getAktifDonem()
        document.title = "Eğitim Araştırmaları Etik Kurulu Başvuru Sorgulama"
    }, []);

    

    return (
        <>

            <div className='relative flex justify-center items-center w-full min-h-screen' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                <div className='mx-auto w-full max-w-4xl pt-11'>
                    <div>
                        <img src={logo} alt='Ordu Üniversitesi' className='mb-6 h-20 mx-auto' />
                    </div>
                    <div className='text-center font-semibold text-slate-500 text-lg'>
                        EĞİTİM ARAŞTIRMALARI ETİK KURUL BAŞVURU SORGULAMA
                    </div>

                    {
                        donem ? (
                            <>
                                <div className='border rounded-md mt-6 mb-6 mx-4 lg:mx-0 px-6 py-8 text-slate-500 space-y-3 text-sm'>
                                    <div className='flex justify-center flex-col items-center gap-y-4'>
                                        <div className='text-center'>Aktif Başvuru Dönemi<br /> Başlama : {donem && donem.donemBasTarTRKisa} - Bitiş : {donem && donem.donemBisTarTRKisa}</div>
                                        <h1 className='text-slate-600 text-2xl'>Başvuru Numaranız</h1>
                                        <input onChange={(e) => { setBasvuruNo(e.target.value) }} type='text' placeholder='' className='text-xl text-center border text-slate-800 font-medium border-slate-300 w-full lg:w-1/2  leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-slate-300 transition-all' />
                                        <span>{error && error}</span>
                                    </div>
                                    <div className='text-center '>
                                        <div className='flex justify-center mb-3'>
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                                onChange={(value) => onChangeRecaptcha(value)} />
                                        </div>
                                        <button onClick={handleSorgulama} disabled={!recaptchaVerified}
                                            className='bg-slate-500 disabled:bg-slate-400 border-slate-400 border hover:bg-slate-400 inline-flex justify-between items-center gap-x-4 text-white text-sm px-4 py-2 rounded-md outline-transparent outline-offset-2 outline-dashed focus:outline-slate-400 focus:outline-1'
                                        >
                                            SORGULA
                                            <span className='text-lg'>
                                                <BsArrowRightCircle />
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                {
                                    basvuruDurum && (
                                        <div className='border rounded-md mt-6 mb-6 mx-4 lg:mx-0 px-6 py-8 text-slate-500 space-y-3 text-sm'>
                                            <p className='text-lg font-semibold text-slate-600'>Sayın Prof. Dr. Selim KANDEMİR,</p>
                                            <p>"{basvuruDetay.arastirmaBasligiTR}" başlıklı araştırmanız için yapmış olduğunuz etik kurul başvurunuz <strong>{handleBasvuruDurum()}</strong>.</p>
                                            <Link target='_blnak' to={`/form-print/${basvuruNo}`} className='text-blue-600 underline'>Başvurunuzu incelemek veya yazdırmak için tıklayınız</Link>
                                            {
                                                basvuruDurum.basvuruDurumu === "2" ? (
                                                    <>
                                                        <p className='font-semibold text-slate-600'>Açıklama</p>
                                                        <p>{basvuruDurum.basvuruDurumAciklama} </p>
                                                    </>
                                                ) : null
                                            }

                                        </div>
                                    )
                                }

                            </>
                        ) : (
                            donem === false ? (
                                <>
                                    <div className='border rounded-md mt-6 mb-6 mx-4 lg:mx-0 px-6 py-8 gap-y-4 text-slate-500 bg-slate-200 text-sm flex flex-col justify-center items-center'>
                                        <BsFillExclamationTriangleFill className='text-3xl text-red-600' />
                                        <div className='text-slate-700 font-medium text-lg'>
                                            Üzgünüz!
                                        </div>
                                        <div>
                                            Etkik kurul başvuruları için aktif başvuru dönemi bulunamamıştır.
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className='relative flex justify-center items-center w-full min-h-screen' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                                    <div className='mx-auto w-full max-w-4xl pt-11'>
                                        <div role="status" className=" animate-pulse">
                                            <div className="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
                                            <div className="h-2 bg-gray-200 rounded-full max-w-[360px] mb-2.5"></div>
                                            <div className="h-2 bg-gray-200 rounded-full mb-2.5"></div>
                                            <div className="h-2 bg-gray-200 rounded-full max-w-[330px] mb-2.5"></div>
                                            <div className="h-2 bg-gray-200 rounded-full max-w-[300px] mb-2.5"></div>
                                            <div className="h-2 bg-gray-200 rounded-full max-w-[360px]"></div>
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        )
                    }



                </div>

            </div>

        </>
    );
}

export default BasvuruSorgulama;
